import { render, staticRenderFns } from "./licenceSet.vue?vue&type=template&id=c4264f62&"
import script from "./licenceSet.vue?vue&type=script&lang=js&"
export * from "./licenceSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports